module.exports = ".MensagemNulo {\r\n    padding-top: 1em;\r\n    margin-bottom: 40px;\r\n}\r\n"